/**
 * Conductor-style browser fingerprint for MFA remember window.
 * Stored in localStorage as browser_computer_id (first 12 hex of SHA-256).
 */
export async function getBrowserComputerId() {
  const key = 'browser_computer_id';
  try {
    const existing = localStorage.getItem(key);
    if (existing && /^[a-f0-9]{12}$/i.test(existing)) {
      return existing;
    }
  } catch {
    /* ignore */
  }

  const scr = typeof window !== 'undefined' ? window.screen : null;
  const parts = [
    navigator.userAgent || '',
    navigator.language || '',
    String(scr?.width ?? ''),
    String(scr?.height ?? ''),
    String(scr?.colorDepth ?? ''),
    String(new Date().getTimezoneOffset()),
    navigator.platform || '',
    String(navigator.hardwareConcurrency || ''),
  ];

  try {
    const canvas = document.createElement('canvas');
    canvas.width = 64;
    canvas.height = 64;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.fillStyle = '#f0f';
      ctx.fillRect(0, 0, 64, 64);
      ctx.fillStyle = '#00f';
      ctx.font = '14px Arial';
      ctx.fillText('asrosync', 4, 24);
      parts.push(canvas.toDataURL());
    }
  } catch {
    /* ignore */
  }

  const raw = parts.join('|');
  let hex;
  if (window.crypto?.subtle) {
    const data = new TextEncoder().encode(raw);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    hex = Array.from(new Uint8Array(digest))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  } else {
    // Fallback: simple hash
    let h = 0;
    for (let i = 0; i < raw.length; i++) {
      h = (Math.imul(31, h) + raw.charCodeAt(i)) | 0;
    }
    hex = Math.abs(h).toString(16).padStart(12, '0');
  }
  const id = hex.slice(0, 12).toUpperCase();
  try {
    localStorage.setItem(key, id);
  } catch {
    /* ignore */
  }
  return id;
}
